
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import GroupMemberEdit from '@cm/internal/GroupMember/GroupMemberEdit.vue';

@Component({
    name: 'group-member-edit-dialog',
    components: {
        GroupMemberEdit,
    },
})
export default class GroupMemberEditDialog extends Vue {
    @Prop({ type: Boolean }) dialog!: boolean;
    @Prop({ type: Boolean }) isEdit!: boolean;

    @Emit() onClick(): void {} // eslint-disable-line @typescript-eslint/no-empty-function

    close(): void {
        this.onClick();
    }
}
